import { render, staticRenderFns } from "./cashbackRecords.vue?vue&type=template&id=5d763133&scoped=true&"
import script from "./cashbackRecords.vue?vue&type=script&lang=js&"
export * from "./cashbackRecords.vue?vue&type=script&lang=js&"
import style0 from "./cashbackRecords.vue?vue&type=style&index=0&id=5d763133&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d763133",
  null
  
)

export default component.exports